export default __webpack_public_path__ + "static/7ca3d6be174622585233ee39f50d1698.png";